/**
 * Utility functions for number formatting
 */
export default () => {
  /**
   * Format a number to a number with fixed decimal places
   * @param value The number to format
   * @param decimalPlaces The number of decimal places to include in the formatted number
   */
  const toFixedDecimals = (value: number, decimalPlaces: number): number => {
    return parseFloat(value.toFixed(decimalPlaces));
  };

  /**
   * Format a number to a string with a specified number of decimal places
   * @param value The number to format
   * @param decimalPlaces The number of decimal places to include in the formatted string
   * @param trim If true, exclude trailing zeros from the formatted string
   */
  const formatNumberToString = (
    value: number,
    decimalPlaces: number,
    trim: boolean = false,
  ): string => {
    let formatted = value.toFixed(decimalPlaces);
    return trim ? parseFloat(formatted).toString() : formatted;
  };

  return { toFixedDecimals, formatNumberToString };
};
